import { atom } from "recoil"

export const CollapseLeftBar = atom({
  key: "CollapseLeftBar",
  default: true,
})
export const CollapseRightBar = atom({
  key: "CollapseRightBar",
  default: true,
})
